import { Breadcrumb } from 'react-bootstrap';
import StyleBreadcrumb from './Breadcrumb.styled';

function AppBreadcrumb({ mainPage, mainPageLink, viewedLicenseId }) {
  return (
    <StyleBreadcrumb>
      <Breadcrumb>
        <Breadcrumb.Item href="/">Dashboard</Breadcrumb.Item>
        <Breadcrumb.Item href={mainPageLink}>{mainPage}</Breadcrumb.Item>
        <Breadcrumb.Item active>{viewedLicenseId}</Breadcrumb.Item>
      </Breadcrumb>
    </StyleBreadcrumb>
  );
}

export default AppBreadcrumb;
